import React, { useCallback, useEffect, useState } from 'react';
import { Layout, message, Skeleton } from 'antd';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { appStyles } from '../../../../styles';
import { GRAPHICS } from '../../../../constants/define/translation';
import { ContentPageHeader } from '../../../molecules/page-header/ContentPageHeader';
import { GraphicsTable } from '../../../organisms/graphics/GraphicsTable';
import { CONFIG_CONTAINER_NAME, getListBlobContainer } from '../../../../utils/azure';
import { ASSETS } from '../../../../types/graphics';
import { MESSAGE_ERROR } from '../../../../constants/message';
import { SpinLoading } from '../../../atoms';

const { Content } = Layout;

export const FittingGraphics = () => {
  const { t } = useTranslation(GRAPHICS);
  const [listBlobs, setListBlobs] = useState<any>();
  const [isLoading, setIsLoading] = useState<any>(false);

  const handleGetAllBlob = useCallback(async (loading?: boolean) => {
    try {
      setIsLoading(loading);
      const response = await getListBlobContainer(CONFIG_CONTAINER_NAME.AZURE_BLOB_CONTAINER_APP_ASSETS);
      if (response.length === 0) {
        setListBlobs([]);
        setIsLoading(false);
        return;
      }
      setListBlobs(
        response
          .filter(r => r.includes(`${ASSETS.FITTING}/`))
          .map((item, index) => ({
            index,
            link: item,
          })),
      );
      setIsLoading(false);
    } catch (e) {
      setListBlobs([]);
      setIsLoading(false);
      message.error(MESSAGE_ERROR.M02);
    }
  }, []);

  const onLoading = useCallback((loading: boolean) => {
    setIsLoading(loading);
  }, []);

  useEffect(() => {
    handleGetAllBlob();
  }, [handleGetAllBlob]);

  return (
    <SpinLoading isLoading={isLoading} absolute>
      <>
        {!listBlobs && <Skeleton />}
        {listBlobs && (
          <Container>
            <Content>
              <ContentPageHeader title={t('title.graphicsFittings')} extra={[]} />
              <GraphicsTable records={listBlobs} onRefresh={handleGetAllBlob} onLoading={onLoading} />
            </Content>
          </Container>
        )}
      </>
    </SpinLoading>
  );
};

const Container = styled.div`
  ${appStyles.paddingComponent}
`;
